export function dispatchWithResponseAndType(response, typeName) {
  return {
    type: typeName,
    json: response,
  };
}
